/// <reference types="vite-plugin-svgr/client" />
import {
  Box,
  Tooltip as MantineTooltip,
  UnstyledButton,
  useMantineTheme,
} from '@mantine/core'

import type { TooltipProps } from '@/components/Tooltip/Tooltip.types'

import QuestionMarkIcon from '@/assets/icons/questionMark.svg?react'

import classes from './Tooltip.module.css'

export function Tooltip({
  isInfo = false,
  withIcon = true,
  ...props
}: TooltipProps) {
  const theme = useMantineTheme()

  return (
    <MantineTooltip {...props} color={theme.other.colors.blue}>
      {withIcon ? (
        <UnstyledButton
          className={`${classes.tooltipButton} ${isInfo && classes.static}`}
        >
          {isInfo ? 'i' : <QuestionMarkIcon />}
        </UnstyledButton>
      ) : (
        <Box miw={0}>{props.children}</Box>
      )}
    </MantineTooltip>
  )
}
